import React from 'react';
import { Link } from 'react-router-dom';
import { PREFIX_URL_WITH_SLASH as PREFIX_URL } from 'constants/CommonUrl';
import { i18n } from 'util/i18n';

const SingleStone = () => {
  const { pathname } = window.location;
  const path = React.useMemo(() => pathname, [pathname]);

  return (
    <div className="subTabInnerDropdown">
      <ul>
        <li className={path === `${PREFIX_URL}/inventory/single-stone/saved-search` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/saved-search`}>Saved Search</Link>
        </li>
        <li className={path === `${PREFIX_URL}/inventory/single-stone/my-demands` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/my-demand`}>Demands</Link>
        </li>
        <li className={path === `${PREFIX_URL}/inventory/single-stone/match-pair` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/match-pair`}>Match Pair</Link>
        </li>
        {/* <li className={path === `${PREFIX_URL}/inventory/single-stone/calibrated` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/calibrated`}>Calibrated</Link>
        </li> */}
        {/* <li className={path === `${PREFIX_URL}/inventory/single-stone/price-configuration` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/price-configuration`}>Price Configuration</Link>
        </li> */}

        <li className={path === `${PREFIX_URL}/inventory/single-stone/show-stone-report` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/show-stone-report`}>Show Stone Report</Link>
        </li>
        <li className={path === `${PREFIX_URL}/inventory/single-stone/quote-day` ? 'active' : ''}>
          <Link to={`${PREFIX_URL}/inventory/single-stone/quote-day`}>{i18n.t('title.offer')} Day</Link>
        </li>
      </ul>
    </div>
  );
};
export default SingleStone;
